import { HeaderNavItem } from "elseware-ui";

function CustomHeaderNavItem({ ...rest }) {
  return (
    <HeaderNavItem
      styles="hover:text-secondary-500 hover:bg-secondary-800/10 transition"
      {...rest}
    />
  );
}

export default CustomHeaderNavItem;
